export const safeParseJson = (raw, maxSize = 100000) => {
  if (typeof raw !== 'string') {
    return { ok: false, value: null, error: 'non-string' };
  }
  if (raw.length > maxSize) {
    return { ok: false, value: null, error: 'size-limit' };
  }
  try {
    return { ok: true, value: JSON.parse(raw), error: null };
  } catch (error) {
    return { ok: false, value: null, error: 'parse-error' };
  }
};
